import { render } from "./BulkDeductibles.vue?vue&type=template&id=1ec381c2&scoped=true&ts=true"
import script from "./BulkDeductibles.vue?vue&type=script&lang=ts"
export * from "./BulkDeductibles.vue?vue&type=script&lang=ts"

import "./BulkDeductibles.vue?vue&type=style&index=0&id=1ec381c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec381c2"],['__file',"src/views/BulkDeductibles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ec381c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ec381c2', __exports__)) {
    api.reload('1ec381c2', __exports__)
  }
  
  module.hot.accept("./BulkDeductibles.vue?vue&type=template&id=1ec381c2&scoped=true&ts=true", () => {
    api.rerender('1ec381c2', render)
  })

}


export default __exports__